import React from 'react';
import { ProgressBar as BootstrapProgressBar, Container } from 'react-bootstrap';

interface ProgressBarProps {
  currentStage: number;
  totalStages: number;
  style?: React.CSSProperties;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStage, totalStages, style }) => {
  const progress = (currentStage / totalStages) * 100;
  return (
    <Container style={{padding: '1rem', position: 'sticky', top: 0, zIndex: 1000} }>
      <BootstrapProgressBar now={progress} label={`${currentStage}/${totalStages}`} style={style} />
    </Container>
  );
};

export default ProgressBar;